import { useEffect, useMemo, useState } from 'react';

import { useResponsive } from '@/hooks/useResponsive';
import { NavBar } from '@/v2/components/NavBar';

import { FirstScreen, FourthScreen, SecondScreen, ThirdScreen } from './components';

/**
 * 首页组件
 * 包含四个屏幕：
 * - 第一屏：首页展示
 * - 第二屏：核心场景与精准策略（含滚动劫持效果）
 * - 第三屏：打字机效果展示
 * - 第四屏：其他内容
 */
export const Home = () => {
  const [isMobileSize, setIsMobileSize] = useState(window.innerWidth < 768);
  const { isMobile: isMobileMeta } = useResponsive();
  const isMobile = useMemo(() => isMobileMeta || isMobileSize, [isMobileMeta, isMobileSize]);
  const [isFlat, setIsFlat] = useState(window.innerWidth < 1280);

  useEffect(() => {
    const checkFlat = () => {
      setIsFlat(window.innerWidth < 1280);
      setIsMobileSize(window.innerWidth < 768);
    };

    checkFlat();
    window.addEventListener('resize', checkFlat);
    return () => window.removeEventListener('resize', checkFlat);
  }, []);

  return (
    <div className={`mx-auto flex flex-col ${isMobile ? 'gap-[120px]' : 'gap-[160px]'}`}>
      {/* 导航栏 - 固定在顶部 */}
      <NavBar />

      {/* 第一屏 */}
      <FirstScreen isFlat={isFlat} isMobile={isMobile} />

      {/* 第二屏 - 滚动劫持区域 */}
      <SecondScreen isFlat={isFlat} isMobile={isMobile} />

      {/* 第三屏 */}
      <ThirdScreen isFlat={isFlat} isMobile={isMobile} />

      {/* 第四屏 */}
      <FourthScreen />
      <div></div>
    </div>
  );
};

export default Home;
